import React, {Component} from 'react';
import {Field, reduxForm} from 'redux-form'
import WizardForm from "./WizardForm";
import showResults from "./showResults";

import {RTLStep} from '../RTLKit';

/* ------ Validate / Warn  -------- */
import ValidateForm from './parts/addValidate';
import WarnForm from './parts/addWarn';

const { Step } = RTLStep;

class AddEditForm extends Component {
    constructor(props) {
        super(props);

        //---- Detect Add or Edit module
        this.state = {
            mode: this.props.match.params.id ? 'edit' : 'add',
            itemId: this.props.match.params.id ? this.props.match.params.id : null, // item id in edit mode
            cities:[],
            formLayout: 'horizontal',
            current: 0,
        };

    }

    onFormSubmit(value) {
        this.props.handleSubmit(value);
    }

    componentWillMount() {
    }

    next() {
        const current = this.state.current + 1;
        this.setState({ current });
    }

    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
    }

    render() {
        var _self = this;
        const {formLayout,current} = _self.state;

        /*---- set mode ---*/
        if(this.props.initialValues) {
            this.props.initialValues.mode=this.state.mode
        }

        /* ----- find selected city  -----*/
        if(this.props.initialValues && this.state.mode == 'edit') {
            this.state.stateId = this.props.initialValues.state
        }

        return (
            <WizardForm onSubmit={this.onFormSubmit.bind(this)} createdUser={this.props.createUser} />
        );
    }

}

export default AddEditForm = reduxForm({
    form: 'addOrder',        // <--- a unique name for the form
    validate: ValidateForm, // <--- validation function given to redux-form
    warn: WarnForm
})(AddEditForm)
